import type { ReactNode } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

export const SELECTED_ID_PARAM = 'selectedId';
export const ATTRIBUTE_PARAM = 'attribute';
export const SCRAPE_METADATA_SITE_PARAM = 'scrapeMetadataSite';
export const DRAWER_TAB_PARAM = 'drawerTab';

export type DrawerTab =
  'HOTEL_SETTINGS' | 'HOTEL' | 'SCRAPE_METADATA' | 'STATUS' | 'RATES' | 'CITY' | 'CITY_STATUS';

export type SelectedType = 'HOTEL' | 'CITY';

export type EditableHotelFieldKey = 'name' | 'homePageUri' | 'bookingEngineType' | 'currencyCode';

export function isObjectRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function formatUnknownValue(value: unknown): ReactNode {
  if (value === null || value === undefined) {
    return '-';
  }

  if (typeof value === 'string') {
    return value ?? '-';
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  return (
    <SyntaxHighlighter
      language="json"
      customStyle={{
        margin: 0,
        padding: '0.5rem',
        borderRadius: '0.375rem',
        fontSize: '0.7rem',
        lineHeight: 1.4,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowX: 'scroll',
      }}
      wrapLongLines
    >
      {JSON.stringify(value, null, 2)}
    </SyntaxHighlighter>
  );
}
